import type { TonoEtichetta } from '../../componenti/base.tsx'

/**
 * Aiuti comuni alle sezioni della scheda persona.
 *
 * `data` non coincide con `giorno` di componenti/elenco.tsx: qui il valore assente vale null,
 * perche' le voci di `Dato` mostrano da sole il trattino, mentre nelle tabelle degli elenchi
 * il trattino va scritto nella cella.
 */
export const data = (v: string | null | undefined) => (v ? new Date(v).toLocaleDateString('it-IT') : null)

export const oggi = () => new Date().toISOString().slice(0, 10)

/** Codici scritti con il trattino basso: in interfaccia si leggono come parole separate. */
export const leggibile = (codice: string) => codice.replace(/_/g, ' ')

/** Stati del percorso: 'aperto', 'sospeso', 'chiuso' (vincolo di core.percorso). */
export const tonoPercorso = (stato: string): TonoEtichetta =>
  stato === 'aperto' ? 'positivo' : stato === 'sospeso' ? 'attenzione' : 'neutro'

/** Stati dell'intervento: 'bozza', 'completo', 'storico_incompleto', 'annullato'. */
export const tonoIntervento = (stato: string): TonoEtichetta =>
  stato === 'completo' ? 'positivo' : stato === 'annullato' ? 'critico' : 'attenzione'
